import { Box, Typography, CircularProgress } from '@mui/material'
import { CheckmarkCircle20Regular, ErrorCircle20Regular } from '@/components/Icon'
import { copyIcon16Sx } from '../shared/copyIconSx.js'

const ToolBlock = ({ toolName, status = 'loading', result }) => {
  return (
    <Box
      sx={{
        my: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        bgcolor: 'background.default',
        borderRadius: 'var(--app-radius-md)',
        p: '6px 10px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        {status === 'loading' && <CircularProgress size={16} sx={{ color: 'text.secondary' }} />}
        {status === 'success' && (
          <Box component="span" sx={{ ...copyIcon16Sx, color: 'success.main' }}>
            <CheckmarkCircle20Regular />
          </Box>
        )}
        {status === 'error' && (
          <Box component="span" sx={{ ...copyIcon16Sx, color: 'error.main' }}>
            <ErrorCircle20Regular />
          </Box>
        )}

        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          {status === 'loading' ? `Running ${toolName}...` : `${toolName}`}
        </Typography>
      </Box>

      {result ? (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {result}
        </Typography>
      ) : null}
    </Box>
  )
}

export default ToolBlock
